import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProductDataSource } from 'app/Model/dataProcess/productDataSource';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { ProductService } from 'app/Services/CatalogManagement/product.service';
import { DataSourcesService } from 'app/Services/DataProcess/datasources.service';
import { LoginService } from 'app/Services/login.service';
import { DxDropDownBoxTypes } from 'devextreme-angular/ui/drop-down-box';
import { ValueChangedEvent } from 'devextreme/ui/text_box';
import { Catalog } from '../../Model/Catalog/Catalog';
import { UserManagementService } from '../../Services/userManagment.service';
import { Address } from "../../Model/Catalog/Address";
import { Brand } from "../../Model/Dto/Brand/Brand";
import { ViewService } from "../../Services/view.service";

@Component({
  selector: 'catalogSupplier',
  templateUrl: 'catalogSupplier.component.html',
  styleUrls: ["catalogSupplier.component.css"],
  standalone: false
})
export class CatalogSupplierComponent implements OnInit {
  productDataSources: ProductDataSource[] = [];
  productDataSource: ProductDataSource = null;
  productDataSourceSuppliers: ProductDataSource[] = [];
  relatedBrands: Brand[] = [];
  countryCodes: { code: string; name: string; label: string }[] = [];
  types: string[] = ['Manufacturer', 'Supplier'];
  newOrUpdateProductDataSource: ProductDataSource;
  selectedDataSourceId?: string = null;
  isEdit: boolean = false;
  existingSupplierSelectedBool: boolean = false;
  existingSupplierSelected: ProductDataSource;
  popupVisible: boolean = false;
  v: boolean[] = [false, false, false, false, false, false, false, false, false, false, false, false, false];
  private MANUALLY_ENTERED_SUPPLIER_ID: string = 'MANUALLY_ENTERED_SUPPLIER';

  constructor(
    public dataSourcesService: DataSourcesService,
    public catalogService: CatalogService,
    public loginService: LoginService,
    public translate: TranslateService,
    public userManagement: UserManagementService,
    public dataSourceService: DataSourcesService,
    public productService: ProductService,
    public cdr: ChangeDetectorRef
  ) {
    this.createNewDataSource = this.createNewDataSource.bind(this);
  }

  _suppliers: ProductDataSource[] = [];

  get suppliers(): ProductDataSource[] {
    return this._suppliers;
  }

  get model(): Catalog {
    return this.catalogService.catalog;
  }

  get showToolTips(): boolean {
    return this.loginService.showToolTips;
  }

  get showProToolTips(): boolean {
    return this.loginService.showProToolTips;
  }

  get showPlaceHolders() {
    return this.loginService.showPlaceHolders;
  }

  ngOnInit(): void {
    this.dataSourceService.getAll(this.userManagement.loginService.currentCustomer.id).then((result) => {
      this.buildSuppliersList(result);
      this.productDataSources = result;
      this.productDataSource = result.find(
        (x) => x.name == this.model.supplier.manufacturer || x.alternativeNames.includes(this.model.supplier.manufacturer)
      );
    });

    ViewService.fetchIsoCountyCodes().then(countries => {
      const list = countries?.length ? countries : ViewService.dropDownTerritories;
      this.countryCodes = list.map(c => ({
        ...c,
        label: `${c.name} (${c.code})`
      }));
    });

  }

  catalogChanged(e: ValueChangedEvent) {
    this.catalogService.catalogChanged(e);
  }


  catalogSupplierChanged(e: any) {

    if(!e?.event){
      return;
    }
    this.catalogService.catalogChanged(e);
    const text = e.component.option('text');
    const chosenSupplier = this.productDataSourceSuppliers.find(x => x.id == e.value || x.alternativeNames.includes(text));
    if (chosenSupplier) {
      this.setSupplierData(chosenSupplier);
    } else {
      this.existingSupplierSelectedBool = false;
    }
  }

  setSupplierData(chosenSupplier: ProductDataSource) {

    this.existingSupplierSelected = chosenSupplier;
    this.existingSupplierSelectedBool = true;
    this.model.supplier.supplierId = chosenSupplier.kreditorNr;
    this.model.supplier.supplierName = chosenSupplier.name;
    this.model.supplier.address.street = chosenSupplier.addressObj.street;
    this.model.supplier.address.contact = chosenSupplier.contactPerson;
    this.model.supplier.address.zip = chosenSupplier.addressObj.zip;
    this.model.supplier.address.city = chosenSupplier.addressObj.city;
    this.model.supplier.address.state = chosenSupplier.addressObj.state;
    this.model.supplier.address.email = chosenSupplier.salesMail;
    this.model.supplier.address.url = chosenSupplier.website;
    this.model.supplier.address.phone = chosenSupplier.salesTel;
    this.model.supplier.address.country = chosenSupplier.countryCode;

  }

  onCustomSupplierCreating(e: any): void {
    const text = (e.text ?? '').toString().trim();

    if (!text) {
      e.customItem = null;
      return;
    }

    // "Fake"-Item bauen, das zu displayExpr/valueExpr passt
    e.customItem = {
      id: text,                 // dummy value damit der info text kleiner wird
      name: text
    };
  }

  onGridBoxOptionChanged(e: DxDropDownBoxTypes.OptionChangedEvent) {
    if (e.name !== 'value') {
      return;
    }

    // dx-drop-down-box kann ein Array von Werten zurückgeben,
    // auch wenn die Mehrfachauswahl deaktiviert ist:
    let newSupplierId = null;
    if (e.value && Array.isArray(e.value)) {
      newSupplierId = e.value[0];
    } else {
      newSupplierId = e.value;
    }

    if (newSupplierId === this.MANUALLY_ENTERED_SUPPLIER_ID) {
      return;
    }

    this.selectedDataSourceId = newSupplierId;

    const newSupplier = this._suppliers.filter((x) => x.id == newSupplierId)[0];
    this.catalogService.catalog.supplier.supplierName = newSupplier.name;
    this.catalogService.catalog.supplier.supplierId = newSupplier.kreditorNr ?? '';
    this.catalogService.catalog.supplier.address.contact = newSupplier.contactPerson ?? '';
    this.catalogService.catalog.supplier.address.street = newSupplier.addressObj?.street ?? '';
    this.catalogService.catalog.supplier.address.zip = newSupplier.addressObj?.zip ?? '';
    this.catalogService.catalog.supplier.address.city = newSupplier.addressObj?.city ?? '';
    this.catalogService.catalog.supplier.address.country = newSupplier.addressObj?.country ?? '';
    this.catalogService.catalog.supplier.address.phone = newSupplier.addressObj?.phone ?? '';
    this.catalogService.catalog.supplier.address.fax = newSupplier.addressObj?.fax ?? '';
    this.catalogService.catalog.supplier.address.email = newSupplier.addressObj?.email ?? '';
    this.catalogService.catalog.supplier.address.url = newSupplier.addressObj?.url ?? '';

    this.catalogService.catalogChanged(e);
  }

  async onManufacturerChange(event) {
    if (!event.event) event.event = new Event('dummy');

    this.productDataSource = this.productDataSources.find(
      (x) => x.name == this.model.supplier.manufacturer || x.alternativeNames.includes(this.model.supplier.manufacturer)
    );

    this.catalogChanged(event);
    if (this.model.supplier.manufacturer?.trim()) {
      this.model.supplier.contact = await this.productService.getSupportContact(
        this.catalogService.catalog.id,
        null,
        this.loginService.currentCustomer.id,
        this.model.supplier.manufacturer
      );
      this.catalogChanged(event);
    }

    this.cdr.detectChanges();
  }

  ttt(id) {
    if (this.loginService.showToolTips) {
      if (!this.v[id]) {
        this.v = [false, false, false, false, false, false, false, false, false, false, false, false, false];
      }
      this.v[id] = !this.v[id];
    }
  }

  canView(name: string): boolean {
    return this.userManagement.canView(name);
  }

  readOnlyUser(name: string): boolean {

    if (name == "supplierAddressFax" || name == "supplierType" || name == "supplierAddressState" || name =="supplierAddressRemarks") return false;

    return !this.userManagement.canEdit(name) || this.existingSupplierSelectedBool == true;


  }

  createNewDataSource() {
    const empty = {addressObj: new Address(), importerAddress: new Address()} as ProductDataSource;
    this.newOrUpdateProductDataSource = empty;
    this.isEdit = false;
    this.relatedBrands = [];
    this.popupVisible = true;
  }

  async editDataSource() {
    const id = this.model.supplier.supplierName;
    this.existingSupplierSelected ??=
      this.productDataSourceSuppliers.find(x => x.id == id || x.alternativeNames.includes(id));
    this.newOrUpdateProductDataSource = this.existingSupplierSelected;
    this.isEdit = true;
    this.relatedBrands = await this.dataSourcesService.getRelatedBrands(this.existingSupplierSelected.id, this.loginService.currentCustomer.id);
    this.popupVisible = true;
  }

  onEditSaved(updatedDataSource: ProductDataSource) {
    const index = this.productDataSourceSuppliers.findIndex(x => x.id === updatedDataSource.id);
    if (index != -1) {
      if (this.existingSupplierSelected.id == updatedDataSource.id) {
        this.setSupplierData(updatedDataSource);
        this.productDataSourceSuppliers[index] = updatedDataSource;
      }
      return;
    }
    this.productDataSourceSuppliers.push(updatedDataSource);

  }

  private buildSuppliersList(result: ProductDataSource[]) {
    this._suppliers = result.filter((x) => x.type == "Manufacturer" || x.type == "Supplier");
    let existingSupplierName = this.catalogService?.catalog?.supplier?.supplierName;
    this.productDataSourceSuppliers = this._suppliers;
    this.existingSupplierSelectedBool = this.productDataSourceSuppliers.some(x => x.name == this.model.supplier.supplierName);
    // Für den Fall, dass zuvor ein manuell eingefügter Lieferant vorhanden war:
    if (existingSupplierName && this._suppliers.filter((x) => x.name == existingSupplierName).length == 0) {
      let dummyDatasource = ProductDataSource.GetEmptyProductDataSource();
      dummyDatasource.id = this.MANUALLY_ENTERED_SUPPLIER_ID;
      dummyDatasource.name = existingSupplierName;
      dummyDatasource.type = this.translate.instant("Manuell gepflegt");
      this._suppliers.push(dummyDatasource);
      this.selectedDataSourceId = dummyDatasource.id;
    } else {
      let supplier = null;
      if (this.catalogService.catalog.supplier.supplierId === '' && existingSupplierName) {
        supplier = result.filter((x) => x.name == existingSupplierName && x.type == "Supplier")[0];
      } else {
        supplier = result.filter((x) => x.kreditorNr == this.catalogService.catalog.supplier.supplierId && x.type == "Supplier")[0];
      }
      this.selectedDataSourceId = supplier.id;
    }
  }

}
